import React, { useState } from "react";
import { toast } from "../../components/ui/use-toast";
import { faDownload, faRefresh } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CustomTooltip from "../../components/CustomTooltip";
import { API, fileUpload } from "../../config";
import moment from "moment";
import { ResponsiveDrawerForm } from "../../components/ResponsiveDrawerForm";
import Spin from "../../components/Spin";
import { Label } from "recharts";
import CustomLabelText from "../../components/CustomLabelText";
import { Button } from "../../components/ui/button";
import { DateInputPicker } from "../../components/DateInputPicker";
import axios from "axios";
// import axios from "axios";

const DownloadABAActionButton = ({
  item,
  trustId,
  id,
  fetchAbas,
  is_reversed,
  is_refund,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const [abaRegenerateDate, setAbaRegenerateDate] = useState(today);
  const [nextModal, setNextModal] = useState(false);

  const toggleShowModal = () => {
    setShowModal(!showModal);
  };

  const downloadLetter = async (path) => {
    try {
      if (path) {
        const response = await axios.get(`${path}`, {
          responseType: "blob",
        });
        const fileData = response.data;
        const url = window.URL.createObjectURL(new Blob([fileData]));
        var a = document.createElement("a");
        a.href = url;
        var file = path.split("/");
        a.setAttribute("download", file[file.length - 1] || "new_aba.aba");
        document.body.appendChild(a);
        a.click();
        a.remove();
      } else {
        toast.error("File does not exist.");
      }
    } catch (e) {
      const errors = e.response?.data?.errors;
      Object.keys(errors).forEach((key) => {
        toast.error(errors[key][0]);
      });
    }
  };

  const handleRefresh = async (sendEmail) => {
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("trust_id", trustId);
      formData.append(
        "transaction_date",
        abaRegenerateDate ? moment(abaRegenerateDate)?.format("DD-MM-YYYY") : ""
      );
      formData.append("send_email", sendEmail);
      formData.append("_method", "put");

      await fileUpload(`${API.REGENERATE_ABA}/${id}`, formData);
      toggleShowModal();
      setLoading(false);
      fetchAbas();
    } catch (e) {
      setLoading(false);
    }
  };

  return (
    <>
      {is_reversed ? (
        <>Reversed</>
      ) : is_refund ? (
        <>Refunded</>
      ) : (
        <span className="flex items-center gap-2 justify-center">
          <CustomTooltip message={"Regenerate ABA File"}>
            <span>
              <FontAwesomeIcon
                icon={faRefresh}
                size="1x"
                onClick={() => {
                  toggleShowModal();
                }}
              />
            </span>
          </CustomTooltip>
          <span>/</span>
          <CustomTooltip message={"Download"}>
            <span>
              <FontAwesomeIcon
                icon={faDownload}
                size="1x"
                onClick={() => {
                  downloadLetter(item?.aba_file);
                }}
              />
            </span>
          </CustomTooltip>
        </span>
      )}

      <ResponsiveDrawerForm
        description={""}
        title={"Regenerate .ABA"}
        handleOpen={() => {}}
        handleClose={() => {
          setNextModal(false);
          setAbaRegenerateDate(new Date());
        }}
        className={"w-1/4"}
        open={showModal}
        buttonClassName={""}
        setOpen={setShowModal}
        mobileCancelHidden={true}
        confirmBox={true}
        write={true}
      >
        <div className="relative">
          {loading && <Spin expand={true} smallModal={true} fullscreen={true}/>}
          <div className="text-center">
            {nextModal ? (
              "Would you like to send remittance advice via email?"
            ) : (
              <>
                <div className="text-center">
                  Please Select Transaction Date
                </div>

                <div className="grid gap-4 mt-4">
                  <div className="grid gap-2 justify-center">
                    <Label htmlFor="file_note">
                      <CustomLabelText
                        required={true}
                        labelText="Transaction Date"
                      />
                    </Label>
                    <DateInputPicker
                      date={abaRegenerateDate ? abaRegenerateDate : new Date()}
                      onSelect={(e) => {
                        setAbaRegenerateDate(e);
                      }}
                      className={"w-[200px] text-left"}
                      inputClassName="w-full"
                      icon={true}
                      disabledDate={{ after: new Date() }}
                    />
                  </div>
                </div>
              </>
            )}
          </div>
          <div className="modal-footer pt-4 border-t mt-4 flex items-center justify-center">
            <Button
              type="submit"
              onClick={(e) => {
                e.preventDefault();
                nextModal ? handleRefresh(1) : setNextModal(true);
              }}
            >
              {nextModal ? "Yes" : "Next"}
            </Button>
            {nextModal && (
              <Button
                className="reset ml-3"
                data-dismiss="modal"
                aria-label="Close"
                variant="secondary"
                onClick={(e) => {
                  e.preventDefault();
                  handleRefresh(0);
                }}
              >
                No
              </Button>
            )}
            <Button
              className="reset ml-3"
              data-dismiss="modal"
              aria-label="Close"
              variant="secondary"
              onClick={(e) => {
                e.preventDefault();
                toggleShowModal();
              }}
            >
              Cancel
            </Button>
          </div>
        </div>
      </ResponsiveDrawerForm>
    </>
  );
};

export default DownloadABAActionButton;
